//packages
import React from 'react';
//global components
import MainMenu from '../../_components/MainMenu';
import PageNotFound from '../../_components/PageNotFound';
import MainFooter from '../../_components/MainFooter';
import PreLoader from "../../_components/PreLoader";
//services
import { menuService } from '../../_services/menu.service';
import { postService } from '../../_services/post.service';
//styles
import './Artist.sass';

class Artist extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: {
        details: {}
      },
      menu: {},
      artist: {},
      branches: [],
      notFound: false,
      topbarMenu: {},
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('user'));
    const slug = this.props.match.params[0];
    if (user && Date.now() < user.expiresAt) {
      this.setState({
        user: user
      });
    } else {
      this.setState({
        user: {
          details: {}
        }
      });
    }

    Promise.allSettled([
      postService.getBySlug(slug).then((artist) => {
        if (artist.length > 0) {
          this.setState({ artist: artist[0]})
        } else {
          this.setState({ notFound: true })
          }
      }),
      menuService.getMenuByName("default").then(menu => this.setState({ menu })),
      menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
      postService.getBranchesFooter('branch').then(branches => this.setState({ branches }))
    ]).then(() => this.setState({ loading: false }));
  }

  render() {
    const { loading, user, menu, topbarMenu, artist, notFound, branches } = this.state;

    return (
      <>
        <PreLoader loading={loading} />
        {!notFound ?
          <>
            <MainMenu user={user} menu={menu} topbarMenu={topbarMenu}/>
            <div className="jumbotron page-title py-5">
              <div className="container"><h1 className="text-white">KORG Artists</h1></div>
            </div>
            {artist &&
            <section className="main-content">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    {artist && artist.title &&
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb bg-transparent m-0">
                          <li className="breadcrumb-item"><a href="/">Home</a></li>
                          <li className="breadcrumb-item"><a href="/artists">Artist</a></li>
                          <li className="breadcrumb-item active" aria-current="page">{artist.title.rendered.replace(' ', '-')}</li>
                        </ol>
                      </nav>
                    }
                  </div>
                  <div className="col-12">
                    <hr className="m-0 mb-4" />
                  </div>
                </div>
               {artist && artist.content &&
                <div className="row">
                  <div className="col-12 mb-5 artist-page" dangerouslySetInnerHTML={{ __html: artist.content.rendered }} />
                </div>
                }
              </div>
            </section>
            }
            <MainFooter menu={menu} branches={branches} />
          </>
          :
          <PageNotFound />
        }
      </>
    );
  }
}

export { Artist };